export default {
  status: {
    waiting: 'Czekaj',
    failed: 'Błąd wysyłania',
    cancelled: 'Anulowano',
    complete: 'Dodano',
    sent: 'Wysłano',
    unsupported: 'Niewspierany format',
    uploading: 'Dodawanie',
    cancel: 'Anuluj',
  },
  form: {
    title: 'Przeciągnij lub wgraj pliki z wykonaną pracą domową',
    dragging: 'Upuść, a wgrywanie rozpocznie się automatycznie',
    action: 'Wgraj plik',
    send_homeworks: 'Wyślij pliki do lektora',
    clear_homeworks: 'Wyczyść listę i wgraj nowe pliki',
    old_files_homeworks: 'Dodane pliki można wysłać w ciągu 24h, po tym czasie trzeba je załadować ponownie.',
    upload_inactive: 'Wysyłanie prac domowych jest dostępne jedynie z konta ucznia.',
  },
};
